// Cited source text shown at each citation pill (2026-10-29).
// With RAG_BLOCK_REF_CITATIONS the agent fills every content citation's `quote`
// with the cited block's real text, so the reader can check a sentence against
// its source by hovering the pill, without opening the document. About 5 % of
// cited sentences still have a meaning problem no automatic check catches
// (merged rows, overstated wording) — this makes them visible.

const MAX_CHARS = 280;
const MIN_CHARS = 6;

/** Display text of a citation's source block, or null (page reference, no or tiny quote). */
export function citationPreview(cit) {
  if (!cit || cit.kind === 'pageref') return null;
  let q = typeof cit.quote === 'string' ? cit.quote : '';
  q = q
    .replace(/^\s*\[XLSX-ROW\]\s*\|\s*/i, '')
    .replace(/^\s*TABLE\s+\d+:\s*/i, '')
    .replace(/\s+\|\s+/g, ' · ')
    .replace(/\s+/g, ' ')
    .trim();
  if (q.length < MIN_CHARS) return null;
  if (q.length > MAX_CHARS) {
    const cut = q.slice(0, MAX_CHARS);
    const sp = cut.lastIndexOf(' ');
    q = (sp > MAX_CHARS * 0.6 ? cut.slice(0, sp) : cut).replace(/[\s·,;:]+$/, '') + ' …';
  }
  return q;
}

/** The pill's tooltip: the open hint as before, then the cited text when there is one. */
export function citationTitle(prettyName, cit, { isCrossDoc = false, isPageRef = false } = {}) {
  const page = cit && cit.page;
  const hint = isCrossDoc
    ? `${prettyName} (andere Quelle als Abschnitts­überschrift) auf Seite ${page} öffnen`
    : isPageRef
      ? `${prettyName} auf Seite ${page} öffnen`
      : `${prettyName} öffnen`;
  const preview = isPageRef ? null : citationPreview(cit);
  return preview ? `${hint}\n\n„${preview}“` : hint;
}
